var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcChipTimePicker(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 15.5234C6.61553 15.5234 5.26216 15.1129 4.11101 14.3437C2.95987 13.5746 2.06266 12.4813 1.53285 11.2022C1.00303 9.92314 0.86441 8.51568 1.13451 7.15781C1.4046 5.79994 2.07129 4.55266 3.05026 3.57369C4.02922 2.59473 5.2765 1.92804 6.63437 1.65794C7.99224 1.38785 9.3997 1.52647 10.6788 2.05628C11.9579 2.5861 13.0511 3.4833 13.8203 4.63445C14.5895 5.78559 15 7.13897 15 8.52344C15 10.38 14.2625 12.1604 12.9497 13.4732C11.637 14.7859 9.85652 15.5234 8 15.5234ZM8 2.52344C6.81332 2.52344 5.65328 2.87533 4.66658 3.53462C3.67989 4.19391 2.91085 5.13098 2.45673 6.22734C2.0026 7.3237 1.88378 8.5301 2.11529 9.69398C2.3468 10.8579 2.91825 11.927 3.75736 12.7661C4.59648 13.6052 5.66558 14.1766 6.82946 14.4082C7.99335 14.6397 9.19975 14.5208 10.2961 14.0667C11.3925 13.6126 12.3295 12.8436 12.9888 11.8569C13.6481 10.8702 14 9.71013 14 8.52344C14 6.93214 13.3679 5.40602 12.2426 4.2808C11.1174 3.15558 9.5913 2.52344 8 2.52344Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.295 11.5234L7.5 8.72844V4.02344H8.5V8.31344L11 10.8184L10.295 11.5234Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChipTimePicker);
export default __webpack_public_path__ + "static/media/ic-chip-time-picker.097cf021eb1208e1f5615f19ef579c8a.svg";
export { ForwardRef as ReactComponent };